import {twJoin} from 'tailwind-merge'

import {IconArrowLeft, IconArrowRight} from '@sdox/icons'

import type {RefObject} from 'react'

export interface TabScrollButtonProps {
  direction: 'left' | 'right'
  scrollRef: RefObject<HTMLElement>
}

export const TabListScrollButton = (props: TabScrollButtonProps) => {
  const {direction, scrollRef} = props

  const onClickButton = () => {
    const element = scrollRef.current
    if (!element) return

    let left = element.scrollLeft
    const scrollDistance = element.clientWidth/2
    if (direction === 'left') {
      left -= scrollDistance
    }
    if (direction === 'right') {
      left += scrollDistance
    }

    element.scrollTo({
      left,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className={twJoin(
        'absolute top-0',
        direction === 'left' && 'left-0',
        direction === 'right' && 'right-0',
      )}
    >
      {/* TODO: replace with new button, when the design team is done */}
      <button
        onClick={onClickButton}
        className={'pointer-events-auto flex size-spacing-44 items-center justify-center rounded-radius-interactive-lg bg-[#DFE2E5]'}
      >
        {direction === 'left' ? <IconArrowLeft /> : <IconArrowRight />}
      </button>
    </div>
  )
}
